export const REQUEST = (type) => `${type}_REQUEST`;
export const SUCCESS = (type) => `${type}_SUCCESS`;
export const FAIL = (type) => `${type}_FAIL`;
